import { ManageMenuFormValue } from './manage-menu.interfaces';

export function createManageMenuFormValue(): ManageMenuFormValue {
  return {
    menu_name: '',
    menu_code: '',
    parent_id: null,
    route_path: '',
    icon: '',
    display_order: null,
    phase: 1,
    is_active: true,
  };
}
